<template>
    <el-tabs :class="mode ? 'mode__lockday' : 'mode__locknight'" :tab-position="tabPosition">
        <el-tab-pane v-if="lockPassword.length > 1" label="Автоблокировка">
            <el-card :class="mode ? 'el__cardday' : 'el__cardnight'">
                <el-col :span="12">
                    <el-form label-position="left" :model="settings" label-width="180px" size="mini">
                        <div>
                            <h5 :class="mode ? 'text__day2' : 'text__night2'">Автоблокировка при неактивности</h5>
                        </div>
                        <div>
                            <el-radio-group :class="mode ? 'mode__radioday' : 'mode__radionight'" v-model="secTimer">
                                <el-radio :label="0">Выключено</el-radio>
                                <el-radio :label="10000">10 секунд</el-radio>
                                <el-radio :label="600000">10 минуту</el-radio>
                                <el-radio :label="3600000">1 часов</el-radio>
                                <el-radio :label="18000000">5 часов</el-radio>
                            </el-radio-group>
                        </div>
                        <el-button class="my-4" @click="updateTimer()" type="primary">Сохранить</el-button>
                    </el-form>
                </el-col>
            </el-card>
        </el-tab-pane>
        <el-tab-pane  label="Код-пароль">
            <el-card :class="mode ? 'el__cardday' : 'el__cardnight'">
                <el-col :span="10">
                    <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="180px" size="medium" class="demo-ruleForm">
                        <div class="mb-2">
                            <h5 :class="mode ? 'text__day2' : 'text__night2'">Пароль</h5>
                        </div>
                        <el-form-item v-if="lockPassword.length > 1" class="mt-2" prop="oldPassword" :label-width="'0px'">
                            <el-input :class="mode ? 'mode_1' : 'mode__2'" placeholder="Введите текущий код-пароль" v-model="ruleForm.oldPassword" show-password></el-input>
                        </el-form-item>
                        <el-form-item class="label__error" prop="password" :label-width="'0px'">
                            <el-input :class="mode ? 'mode_1' : 'mode__2'" placeholder="Введите новый код-пароль" v-model="ruleForm.password" show-password></el-input>
                        </el-form-item>
                        <el-form-item class="label__error" prop="confirmPassword" :label-width="'0px'">
                            <el-input :class="mode ? 'mode_1' : 'mode__2'" placeholder="Повторите код-пароль" v-model="ruleForm.confirmPassword" show-password></el-input>
                        </el-form-item>
                        <el-button class="mb-4 mt-2" @click="setLockPass('ruleForm')" type="primary">Сохранить</el-button>
                    </el-form>
                </el-col>
            </el-card>
        </el-tab-pane>

    </el-tabs>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LockScreenMixin  from '../../utils/mixins/LockScreenMixin'
    const bcrypt = require('bcryptjs')
    const salt = bcrypt.genSaltSync(10)

    export default {
        mixins: [LockScreenMixin],
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('Пожалуйста, введите пароль'));
                } else {
                if (this.ruleForm.password !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('Пожалуйста, введите пароль еще раз'));
                } else if (value !== this.ruleForm.confirmPassword) {
                callback(new Error('Пароль не совпадает!'));
                } else {
                callback();
                }
            };
            return {
                tabPosition: 'left',
                secTimer: 60,
                is_can_reload: false,
                correct: false,
                ruleForm: {
                    oldPassword: '',
                    password: '',
                    confirmPassword: '',
                },
                rules: {
                    password: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    confirmPassword: [
                        { validator: validatePass2, trigger: 'blur' }
                    ]
                }
            }
        },
        watch: {
            password() {
                this.correct = false
            },
            oldPassword() {
                this.correct = false
            },
            confirmPassword () {
                this.correct = false
            }
        },
        mounted () {
            this.secTimer = this.timer
        },
        computed: {
            ...mapGetters({
                timer: 'getLockTimer',
                test: 'getLockBool',
                mode: 'MODE'
            }),
        },
        methods:{
            lockUser(){
                // set lock password if it's not set
                if(this.lockPassword === ''){
                    this.showSetLockPasswordModal = true;
                } else {
                    this.TRIGGER_LOCK({ status: true });
                }
            },
            updateTimer () {
                this.$store.commit('setLockTimer', this.secTimer)
                this.is_can_reload = true
                if (this.is_can_reload) {
                    location.reload();
                }
            },
            setLockPass(formName){
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.lockPassword) {
                        if (bcrypt.compareSync(this.ruleForm.oldPassword, this.lockPassword)) {
                            this.UPDATE_PASSWORD({
                                password: bcrypt.hashSync(this.ruleForm.password, salt)
                            });
                            this.ruleForm.password = ''
                            this.ruleForm.oldPassword = ''
                            this.ruleForm.confirmPassword = ''
                            this.$notify({
                                title: 'Успешно',
                                message: 'Успешно',
                                type: 'success',
                            });
                        } else {

                        }
                    } else {
                        this.UPDATE_PASSWORD({
                            password: bcrypt.hashSync(this.ruleForm.password, salt)
                        });
                        this.ruleForm.password = ''
                        this.ruleForm.oldPassword = ''
                        this.ruleForm.confirmPassword = ''
                        this.$notify({
                            title: 'Успешно',
                            message: 'Успешно',
                            type: 'success'
                        });

                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });

            }
        }
    }
</script>
<style>
    .el-select {
        width: 100% !important;
    }
    .border__notcorrect input {
        border-color: crimson !important;
    }
    .border__notcorrect input:hover {
        border-color: rgb(182, 0, 36) !important;
    }
    .label__error .el-form-item__error {
        padding-top: 12px !important;
    }
    .text__day {
    color: #fff;
}
.text__night {
    color: #000;
}
.mode__radionight .el-radio__inner {
    background: inherit !important;
    border: 1px solid inherit !important;
}
.mode__radionight .el-radio {
    color: #fff !important;
}
.mode__locknight .el-tabs__item {
    color: #fff;
}
.el-tabs__item.is-active {
    color: #409EFF !important;
}
.label__night label {
    color: #fff !important;
}
.checkbox__night .el-checkbox__inner {
    background: inherit;
}
</style>
